export default __webpack_public_path__ + "static/media/5_image_4.6e2b24ce.jpg";